import { render, staticRenderFns } from "./AppValidationDescription.vue?vue&type=template&id=2b8d2b16&scoped=true&"
import script from "./AppValidationDescription.vue?vue&type=script&lang=js&"
export * from "./AppValidationDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d2b16",
  null
  
)

export default component.exports